export function initPopups() {

	let siteURL;

  $('a.popuplink').magnificPopup({
    type: 'ajax',
    removalDelay: 800,
    mainClass: 'mfp-animate',
    closeBtnInside:true,
    fixedContentPos:true,
    closeMarkup :
    `<button title="%title%" type="button" class="mfp-close no-barba"><span>+</span></button`,
    callbacks: {

    parseAjax: function(mfpResponse) {
      mfpResponse.data = $(mfpResponse.data).find('.main-single');
    },

	  ajaxContentAdded: function() {
	  	siteURL = window.location.href ;
      history.pushState('', '', this.currItem.src);
    },

	  afterClose: function() {
      history.pushState('', '', siteURL);
    }

    }
  });

}
